module.exports = __webpack_public_path__ + "img/display-img.0ae0c017.svg";